import {
  Pagination as AntdPagination,
  PaginationProps as AntdPaginationProps,
} from "antd";
import { CMP_PREFIX } from "@/base/constant";

export interface PaginationProps extends AntdPaginationProps {}

export const paginationPrefixCls = `${CMP_PREFIX}-pagination`;

export const Pagination = ({ ...props }: PaginationProps) => {
  return <AntdPagination {...props} />;
};
